import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

var disclosureTextIsInViewport = false;
function initAdvertisingDisclosureScript() {
  var disclosureLabel = document.querySelector('[data-hook="open-advertising-disclosure"]');
  var disclosureText = document.querySelector('section[data-role="advertising-disclosure"]');

  if (!disclosureText || !disclosureLabel) {
    return;
  }

  var observer = createObserverInstance();
  disclosureLabel.addEventListener('click', function clickHandler() {
    if (isDeviceSupportsTouch()) {
      observer.observe(disclosureText);
      scrollToDisclosureText();
    }
  });
}

var scrollToDisclosureText = function scrollToDisclosureText() {
  if (!disclosureTextIsInViewport) {
    window.requestAnimationFrame(scrollToDisclosureText);
    window.scrollBy(0, 100);
  }
};

var createObserverInstance = function createObserverInstance() {
  return new IntersectionObserver(function (entries) {
    var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];

    disclosureTextIsInViewport = entry.isIntersecting;
  }, {
    threshold: 1
  });
};

var isDeviceSupportsTouch = function isDeviceSupportsTouch() {
  return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
};

export { initAdvertisingDisclosureScript };
